import React, { FC } from 'react';
import { CopyAsCsvProps } from './CopyAsCsv.props';

import CopyAsCsvView from './CopyAsCsv.view';
import { errorToast } from 'utils/errorToast';
import { successToast } from 'utils/successToast';
import { convertToCsv } from 'utils/convertToCsv';

const CopyAsCsvContainer: FC<CopyAsCsvProps> = ({
  data,
  title = 'Copy To Clipboard',
  showIcon = false,
}) => {
  const copyToClipboard = () => {
    const csvContent = convertToCsv(data);
    const csvBlob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const csvUrl = URL.createObjectURL(csvBlob);

    navigator.clipboard
      .writeText(csvContent)
      .then(() => {
        successToast('Copied to clipboard');
        URL.revokeObjectURL(csvUrl);
      })
      .catch((err) => {
        errorToast('Failed To Copy');
      });
  };

  return (
    <CopyAsCsvView
      copyToClipboard={copyToClipboard}
      title={title}
      showIcon={showIcon}
    />
  );
};

export default CopyAsCsvContainer;
